<main id="foundation_main">
  <!-- <app-navbar></app-navbar> -->
  <!-- <h1 id="title_foundation">A Fundação</h1> -->

  <section id="page_main">
    <div class="foundation">
      <h1 id="title_foundation">A Fundação</h1>

      <section class="foundation_letter_president">
        <div id="letter_president">
          <h1 class="title-blue" id="title_president">
            Carta do<br />Presidente
          </h1>

          <p class="text_letter"></p>
        </div>

        <div id="text_letter_foundation">
          <article>
            <p class="text_president">
              A Fundação Padre Leonel Franca (FPLF) foi criada em 1983 com a
              missão de gerir projetos e programas de interesse da sociedade, em
              sintonia com os propósitos.
            </p>
            <p class="text_president">
              A Fundação Padre Leonel Franca (FPLF) comemora, neste ano de 2023,
              40 anos destinados à gestão de projetos e atividades de relevante
              retorno técnico, sociocultural, educacional, científico e de
              relações com instituições dedicadas a iniciativas acadêmicas de
              fomento à pesquisa.
            </p>
            <p class="text_president">
              Em harmonia com os princípios da PUC-Rio, a FPLF, ao longo dessas
              quatro décadas, assume como missão cooperar com o “desenvolvimento
              do ensino e aprofundamento da investigação e da pesquisa, para
              criar e difundir uma visão do Universo e do ser humano consciente
              da necessária unidade que deve reger a multiplicidade do saber,
              das culturas e da responsabilidade social, contribuindo para o
              desenvolvimento do país” (Estatuto PUC-Rio).
            </p>
          </article>

          <article>
            <p class="text_president">
              Presidir uma Fundação em parceria com uma Instituição que
              contribui para a formação de profissionais que colocam a ciência a
              serviço da comunidade e empenha-se para a construção de um mundo
              mais justo e fraterno é uma alegria e, ao mesmo tempo, um
              compromisso com a sociedade. Tecer sonhos que se concretizem em
              realidades sólidas na construção de conhecimentos e valores éticos
              é o nosso compromisso.
            </p>

            <p class="text_president">
              Por acreditar que a educação é uma das trajetórias mais eficazes
              para humanizar o mundo e nos levar a uma nova sociedade
              acolhedora, que promove a solidariedade universal, a tolerância,
              compreensão e o diálogo, a FPLF continua a seguir seu caminho
              confiando que a pesquisa, valorização da cultura, responsabilidade
              social, o conhecimento e a larga experiência que os quarenta anos
              passados nos oferece, permitem que o presente coabite no futuro e
              o futuro já exista no presente.
            </p>
          </article>

          <div id="name_president">
            <img
              loading="lazy"
              src="../../../assets/imagens/Pe. Roberto Barros Dias, sj@2x.png"
              alt=""
            />
          </div>
        </div>
      </section>
    </div>
  </section>

  <section id="second_page">
    <div id="mission_institutional">
      <h1 class="title-blue" id="title_mission">Missão<br />Institucional</h1>

      <p class="text_misson_puc">
        A Fundação Padre Leonel Franca (FPLF) foi instituída em 1983, com a
        missão de proporcionar maior dinamismo no estabelecimento de relações
        contratuais, visando o atendimento de interesses da sociedade, em
        sintonia com os propósitos da Pontifícia Universidade Católica do Rio de
        Janeiro (PUC-Rio). É uma instituição autônoma, sem fins lucrativos,
        vinculada à Universidade, que amplifica o impacto positivo da academia
        na sociedade e vice-versa.
      </p>

      <p class="text_misson_puc">
        A Fundação articula projetos e coordena a gestão de contratos de
        relevante retorno técnico, científico e sociocultural. Na realização de
        suas atividades, está habilitada a relacionar-se com outras instituições
        semelhantes de natureza pública e privada, sendo credenciada junto a
        diversos órgãos de fomento à pesquisa, desenvolvimento e inovação.
      </p>

      <p class="text_misson_puc">
        Sediada no Campus da PUC-Rio, no bairro da Gávea, na cidade do Rio de
        Janeiro, beneficia-se da infraestrutura de um moderno parque
        tecnológico, de laboratórios de pesquisa em diferentes áreas de
        conhecimento e da excelência de pesquisadores, mestres e doutores da
        Universidade. Sua estrutura orgânica permite agilidade na contratação e
        articulação de projetos de PD&I (Pesquisa, Desenvolvimento e Inovação)
        com Instituições Privadas e com a Administração Pública, executados pela
        PUC-Rio.
      </p>

      <p class="text_misson_puc">
        Ao longo de quatro décadas, a Fundação Padre Leonel Franca atuou na
        gestão de mais de 3.000 projetos de elevada importância acadêmica.
        Acumula uma longa tradição e experiência na execução de tarefas que
        exijam excelência científica e tecnológica. Ao logo dos 40 anos de
        história da FPLF em torno de 10.000 pessoas, diretamente ligadas aos
        seus projetos, vêm escrevendo sua história e tecendo sonhos e
        realidades.
      </p>
    </div>

    <div class="image_pink">
      <img
        loading="lazy"
        id="img_puc_rio"
        src="../../../assets/imagens/fundacao_building.png"
        alt=""
      />
    </div>
  </section>

  <section id="third_page">
    <div>
      <h1 class="title-blue">O Jesuíta<br />Padre Leonel Franca</h1>
      <section id="about_life_priest">
        <div class="text_about_life">
          <div class="life_priest">
            <p class="text_priest">
              Fundador e primeiro reitor da Pontifícia Universidade Católica do
              Rio de Janeiro (PUC-Rio), Padre Leonel Edgard da Silveira Franca
              S.J. nasceu em 06 de janeiro de 1893, em São Gabriel, Rio Grande
              do Sul. Homem de profunda influência cultural e religiosa no
              Brasil, Padre Leonel Franca dedicou cerca de seus últimos dez anos
              à fundação e consolidação da primeira universidade particular do
              país. Conferencista de cultura profunda e vasta, suas palestras
              representavam acontecimento intelectual de primeiro plano. Nessas
              ocasiões levava a auditórios lotados figuras ilustres como
              Epitácio Pessoa, Pandiá Calógeras, Jackson de Figueiredo, Alceu
              Amoroso Lima, Sobral Pinto e Murilo Mendes.
            </p>
            <p class="text_priest">
              Ingressou na Companhia de Jesus em 1908, depois de completados os
              estudos no Colégio Anchieta em Nova Friburgo, RJ. Em 1910 iniciou
              o curso de Letras e, em 1912, seguiu para Roma, onde cursou o
              triênio de Filosofia na Universidade Gregoriana. Voltou ao Rio em
              1915 e iniciou o magistério no Colégio Santo Inácio. Seu primeiro
              livro, "Noções de História da Filosofia" surgiu como prolongamento
              das aulas que ministrava, texto que se tornaria um "best seller",
              sendo lido, citado e usado em cursos de Filosofia até os dias de
              hoje.
            </p>
            <p class="text_priest">
              Em 1920, retornou à Roma para o curso de Teologia de quatro anos,
              tendo sido ordenado Sacerdote em 1923, ano em que publicou outra
              obra de grande relevância: "A Igreja, a Reforma e a Civilização".
              No ano seguinte, doutorou-se em Filosofia e Teologia e, em
              novembro de 1925, completou, em Oya na Espanha, o último ano da
              formação jesuítica, a chamada "Terceira Provação".
            </p>
            <p class="text_priest">
              Entre os anos de 1926 e 1927, Leonel Franca ensinou Filosofia aos
              estudantes jesuítas, em Nova Friburgo, e se transferiu
              definitivamente para o Rio de Janeiro em 1927, onde publicou
              várias obras importantes, entre as quais "A Psicologia da Fé", "O
              Divórcio", "O Problema de Deus" e, talvez a mais notável delas, "A
              Crise do Mundo Moderno". Sendo, em 1931, nomeado para o Conselho
              Nacional de Educação, do qual foi um dos fundadores.
            </p>
          </div>

          <div class="life_priest">
            <p class="text_priest">
              Em 1939, o Concílio Plenário dos Bispos do Brasil decidiu criar a
              Universidade Católica do Brasil, no Rio de Janeiro. Dom Sebastião
              Leme, Cardeal Arcebispo do Rio, encarregou seu conselheiro, Pe.
              Leonel Franca, de incumbir-se desta missão.
            </p>
            <p class="text_priest">
              O decreto presidencial que autorizou o funcionamento das
              Faculdades Católicas foi publicado em 30 de outubro de 1940, pelo
              então presidente Getúlio Vargas, em resposta a Dom Sebastião Leme,
              após criação da Associação Civil Faculdades Católicas. Em dezembro
              do mesmo ano, Padre Leonel Franca, S.J., assume as funções de
              Reitor das Faculdades Católicas. As atividades dos primeiros
              cursos, Direito e Filosofia, iniciaram em março de 1941. A partir
              de então, Padre Franca e seus colaboradores trabalharam para
              estruturar a Escola de Serviço Social, o que permitiu a
              constituição da Universidade Católica, em 15 de janeiro de 1946,
              por meio do Decreto 8.681. Em 20 de janeiro do ano seguinte, por
              um Decreto da Congregação dos Seminários, a Universidade recebeu o
              título de Pontifícia, a Pontifícia Universidade Católica do Rio de
              Janeiro (PUC-Rio). Pe. Leonel Franca, por sua liderança inconteste
              e reconhecimento de sua cultura intelectual e acadêmica, dirigiu a
              Universidade desde sua fundação até sua morte a 03 de setembro de
              1948.
            </p>
            <p class="text_priest">
              Em 1983, buscando proporcionar um maior dinamismo ao
              estabelecimento de relações contratuais com a PUC-Rio, visando o
              atendimento de interesses da sociedade, em sintonia com os
              propósitos da Universidade, foi instituída a Fundação Padre Leonel
              Franca (FPLF), que leva o nome de Pe. Leonel Franca em homenagem
              as suas relevantes contribuições para a PUC-Rio e para a
              sociedade.
            </p>
          </div>
        </div>

        <div id="img_priest_leonal_parent">
          <img
            loading="lazy"
            id="img_priest_leonal"
            src="../../../assets/imagens/Mask Group 23@2x.png"
            alt=""
          />
        </div>
      </section>
    </div>
  </section>

  <section id="fourth_page">
    <div>
      <h1 class="title-white">A PUC-RIO</h1>
      <section id="about_life_priest">
        <div class="text_about_life">
          <div class="life_priest">
            <p class="text_priest">
              A Pontifícia Universidade Católica do Rio de Janeiro (PUC-Rio) é
              uma instituição comunitária de Educação Superior, de acordo com
              Portaria 679, de 12/11/2014, da Secretaria de Regulação e
              Supervisão da Educação Superior, filantrópica e sem fins
              lucrativos, que visa produzir e propagar o saber a partir das
              atividades de ensino, pesquisa e extensão, tendo por base o
              pluralismo e debates democráticos, objetivando, sobretudo, a
              reflexão, o crescimento e enriquecimento da sociedade.
            </p>
            <p class="text_priest">
              A internacionalização do ensino e o intercâmbio entre culturas e
              saberes são propostas acolhidas pela PUC-Rio diante de um mundo
              globalizado. O campus, construído em uma área de 104 mil metros
              quadrados, permite a integração entre cursos e possibilita o
              desenvolvimento de projetos multidisciplinares. A PUC-Rio busca a
              excelência na pesquisa, no ensino e na extensão para a formação de
              profissionais competentes, habilitados ao pleno desempenho de suas
              funções.
            </p>
            <p class="text_priest">
              A Universidade destina todos os seus recursos à consecução dos
              objetivos definidos em seus Estatutos, a saber:
            </p>

            <p class="text_priest">
              • A promoção da cultura, nos planos intelectual, estético, moral e
              espiritual, em função do compromisso com os valores cristãos e
              como instrumento de realização da vocação integral da pessoa
              humana;
            </p>

            <p class="text_priest">
              • O desenvolvimento do ensino e aprofundamento da investigação e
              da pesquisa, para criar e difundir uma visão do Universo e do ser
              humano consciente da necessária unidade que deve reger a
              multiplicidade do saber;
            </p>

            <p class="text_priest">
              • A formação de profissionais competentes, habilitados ao pleno
              desempenho de suas funções, com sentido de responsabilidade e
              participação;
            </p>

            <p class="text_priest">
              • A inserção na realidade brasileira, colocando a ciência a
              serviço da comunidade e orientando suas atividades para a
              edificação de um mundo melhor, de acordo com as exigências da
              Justiça e do Amor;
            </p>

            <p class="text_priest">
              • O intercâmbio e a cooperação com instituições educacionais,
              científicas e culturais, nacionais e estrangeiras, no intuito de
              emprestar universalidade ao sentido de sua missão.
            </p>

            <p class="text_priest">
              O modelo da PUC-Rio procura integrar a graduação com
              pós-graduação, pesquisa e extensão, incentivando no aluno o gosto
              pela pesquisa desde o início de sua formação.
            </p>
          </div>

          <div class="life_priest">
            <p class="text_priest">
              Os cursos de Mestrado e de Doutorado oferecidos pela Universidade
              são subsequentemente agraciados com os mais elevados graus de
              avaliação da CAPES (Coordenação de Aperfeiçoamento de Pessoal de
              Nível Superior). A nota máxima resulta de ampla e criteriosa
              avaliação trienal e é dada exclusivamente a programas com nível de
              excelência e reconhecimento internacional na respectiva área.
            </p>

            <p class="text_priest">
              Outra característica diferenciada da PUC-Rio, detalhada em seu
              Plano de Desenvolvimento Institucional (PDI), é a
              proporcionalidade de seu corpo docente com titularidade de Mestre
              e Doutor.
            </p>

            <p class="text_priest">
              A PUC-Rio mantém permanente contato com instituições públicas e
              privadas que desenvolvem pesquisa de ponta no país, ampliando essa
              atividade para além de seu sentido estritamente acadêmico. As
              parcerias permitem que a Universidade oriente suas pesquisas em
              sintonia com os objetivos de diversos setores de desenvolvimento e
              inovação técnico científico. Desta forma consegue recursos para a
              capacitação de seu corpo docente e discente e viabiliza a
              transferência de tecnologia gerada no ambiente universitário para
              a sociedade.
            </p>

            <p class="text_priest">
              Sua estrutura flexível e orgânica, com ênfase na
              multidisciplinaridade, foi, mais tarde, seguida pelas demais
              universidades brasileiras. Primeira Universidade particular do
              Brasil e a pioneira na adoção do sistema de créditos. De igual
              forma, foi a primeira universidade da América Latina a instalar um
              computador de grande porte, ainda na década de 60.
            </p>

            <p class="text_priest">
              A PUC-Rio traz a marca da vanguarda do ensino e da pesquisa, sendo
              anualmente agraciada com posições de destaque em diferentes
              rankings, cabendo destacar sua liderança sucessivamente na América
              Latina no que se refere a parcerias com empresas, no ranking da
              Times Higher Education Latin American University.
            </p>

            <p class="text_priest">
              Por sua atuação nos mais diversos projetos de pesquisa,
              financiados por organismos governamentais ou empresas privadas ou
              estatais, incluindo projetos de capacitação e de desenvolvimento
              de recursos humanos e de pesquisa e desenvolvimento científico e
              tecnológico, consubstanciados pela publicação de mais de uma
              infinidade de trabalhos científicos sob forma de artigos em
              revistas especializadas, artigos em anais de congressos e
              conferências e de livros, a PUC-Rio colabora com o diferencial
              completivo de seus parceiros e o desenvolvimento econômico do
              País.
            </p>

            <p class="text_priest">
              Mais informações sobre a PUC-Rio estão disponíveis no site
              <a
                href="https://www.puc-rio.br"
                target="_blank"
                rel="noopener noreferrer"
                >www.puc-rio.br</a
              >.
            </p>
          </div>
        </div>

        <div id="img_priest_leonal_parent">
          <img
            loading="lazy"
            id="img_priest_leonal"
            src="../../../assets/imagens/Union_1.png"
            alt=""
          />
        </div>
      </section>
    </div>
  </section>

  <section id="fifth_page">
    <h1 class="title-pink">A FPLF E A PUC-RIO</h1>

    <div class="fifth_page_content">
      <div class="fifth_page_text">
        <p>
          A PUC-Rio conta com o apoio da Fundação Padre Leonel Franca como
          catalizadora do desenvolvimento institucional, científico e
          tecnológico, trazendo mais agilidade, facilidade e segurança jurídica
          às pesquisas produzidas.
        </p>

        <p>
          Cabe a FPLF a gestão administrativa e financeira de contratos, que
          engloba atividades administrativas como avaliação legal da
          documentação e um conjunto de processos e estratégias que garantem
          eficiência, controle dos contratos e evita riscos que possam ocorrer
          durante as etapas.
        </p>

        <p>
          A Fundação recebeu, desde a sua instituição, a aprovação anual de suas
          contas pela Curadoria de Fundações da Capital, organismo controlador
          do Ministério Público.
        </p>

        <p>
          Desta forma, os instrumentos jurídicos firmados possuem a qualificação
          da PUC-Rio e FPLF seguindo o arcabouço que se segue:
        </p>

        <p id="text_italico">
          A <strong>FACULDADES CATÓLICAS</strong>, associação sem fins
          lucrativos, declarada de utilidade publica pelo Decreto Federal nº.
          43.454/58 e reconhecida como de fins filantrópicos pelo Conselho
          Nacional de Assistência Social, registrada sob o nº. 20081202-1626028,
          em 9 de janeiro de 2009, no Registro Civil de Pessoas Jurídicas,
          inscrita no CNPJ sob o nº. 33.555.921/0001-70, inscrição municipal nº.
          00.819.271, mantenedora da
          <strong
            >PONTIFÍCIA UNIVERSIDADE CATÓLICA DO RIO DE JANEIRO -
            PUC-Rio</strong
          >, qualificada pela Portaria 679, de 12 de novembro de 2014, da
          Secretaria de Regulação e Supervisão da Educação Superior, como
          Instituição Comunitária de Educação Superior (ICES), com sede na Rua
          Marquês de São Vicente, nº. 225, Rio de Janeiro - RJ, doravante
          denominada PUC-RIO, neste ato representada na forma de seu Estatuto,
          tendo como Gestora Administrativa a
          <strong>FUNDAÇÃO PADRE LEONEL FRANCA - FPLF</strong>, fundação de
          direito privado estabelecida na Rua Marquês de São Vicente, nº 225,
          Gávea, CEP 22451-041 na Cidade e Estado do Rio de Janeiro, inscrita no
          CNPJ sob o nº 28.019.214/0001-29, denominada simplesmente
          <strong>FPLF</strong>, neste ano representada pelo seu presidente e
          vice-presidente.
        </p>

        <p>
          Assim, a FPLF atua, há 40 anos (dede 1983), junto à PUC-Rio, com
          responsabilidade, transparência e dedicação, na melhoria da execução
          de projetos das mais diversas áreas do ensino, pesquisa e extensão.
        </p>
      </div>
      <img
        loading="lazy"
        class="puc_image"
        src="../../../assets/imagens/Mask_Group_21.png"
        alt=""
      />
    </div>
  </section>

  <section id="six_page">
    <h1 class="title-pink">A Fundação</h1>

    <strong>
      Uma obra de arte intitulada: Leonel Franca - entre Anchietas e Vieiras.
    </strong>

    <div class="six_page_content">
      <blockquote class="six_page_text">
        <p>
          É comum ouvirmos falar que um texto foi escrito a quatro mãos. Este
          que lhes apresentamos foi uma obra escrita não por quatro mãos, mas
          por doze mãos, envolvendo uma rede de instituições de ensino e
          arquivos históricos.
        </p>

        <p>
          O livro comemorativo dos 40 anos de aniversário da Fundação Padre
          Leonel Franca foi buscar em uma correspondência de Antonio Camilo,
          escrita em 20 de setembro de 1948, a inspiração para seu título.
        </p>

        <p>
          Organizado em duas partes, o livro traz, primeiro, a vida de Leonel
          Franca, em uma linha do tempo ilustrada com imagens de seu tempo e de
          seu povo, reconstruindo sua trajetória do nascimento, em São
          Gabriel-RS, à Missão de Reitor da PUC, no Rio de Janeiro, até 1948. A
          segunda parte dá voz a intelectuais e religiosos que apresentam as
          várias faces de Pe. Franca. São textos, retratos, olhares fotográficos
          sobre o amigo humano e místico, o sacerdote, o professor, o filósofo
          que deixou uma vasta produção intelectual, considerada a mais
          influente da cultura brasileira na primeira metade do século XX.
        </p>

        <p>
          Há ainda um espaço intermediário entre a Trajetória e os Olhares sobre
          o <strong>“luzeiro, comparável aos Anchietas e Vieiras”,</strong>, uma
          ponte entre a primeira e a segunda parte, que é arquitetada por
          poesias de autoria do próprio Leonel Franca.
        </p>

        <p>
          Em síntese, a Editora PUC-Rio e a FPLF, com a participação especial
          das Edições Loyola, nos oferecem mais do que um documento histórico,
          uma verdadeira obra de arte intitulada:
          <strong> Leonel Franca - entre Anchietas e Vieiras.</strong>
        </p>

        <p>Uma boa contemplação e uma boa leitura para todos nós.</p>

        <div id="name_president">
          <img
            loading="lazy"
            src="../../../assets/imagens/Pe. Roberto Barros Dias, sj@2x.png"
            alt=""
          />
        </div>
      </blockquote>

      <a
        href="assets/11 PUC livro padre leonel franca DIGITAL.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          loading="lazy"
          class="puc_image"
          src="assets/Capa do livro FPLF-1.png"
          alt=""
        />
      </a>
    </div>
  </section>

  <!-- <app-footer></app-footer> -->
</main>
